export const TicketAdminFilterKey = {
  Status: 'status',
  Priority: 'priority',
} as const;
export type TicketAdminFilterKey = (typeof TicketAdminFilterKey)[keyof typeof TicketAdminFilterKey];
export const TICKET_ADMIN_FILTER_KEYS = [TicketAdminFilterKey.Status, TicketAdminFilterKey.Priority] as const;
